const host = (u) => {
  try {
    return new URL(u).host;
  } catch {
    return "";
  }
};

export const SITE_HOST = host(process.env.REACT_APP_SITE_URL);
export const APP_HOST = host(process.env.REACT_APP_APP_URL);
export const CONSOLE_HOST = host(process.env.REACT_APP_CONSOLE_URL);

// Only the real domains get split; preview or any other address keeps everything on one host.
const onDomain = () => [SITE_HOST, `www.${SITE_HOST}`, APP_HOST, CONSOLE_HOST].includes(window.location.host);

const href = (base, path) => (!onDomain() || host(base) === window.location.host ? path : base.replace(/\/$/, "") + path);
export const appHref = (path = "/connexion") => href(process.env.REACT_APP_APP_URL, path);
export const consoleHref = (path = "/console/connexion") => href(process.env.REACT_APP_CONSOLE_URL, path);
export const isExternal = (u) => /^https?:\/\//.test(u);

export function hostRedirect(pathname) {
  if (!onDomain() || (SITE_HOST === APP_HOST && APP_HOST === CONSOLE_HOST)) return null;
  const h = window.location.host;
  if (h === CONSOLE_HOST) return pathname.startsWith("/console") ? null : "/console";
  if (h === APP_HOST) {
    if (pathname.startsWith("/console")) return consoleHref(pathname);
    return pathname === "/" ? "/app" : null;
  }
  if (pathname.startsWith("/console")) return consoleHref(pathname);
  if (pathname.startsWith("/app") || pathname === "/connexion") return appHref(pathname);
  return null;
}
